import { useState } from "react";
import { TaxRegimeTable, InvestmentTypesTable, TaxSectionTable, AgeRangeForTaxSlabTable, TaxSlabTable, SurchargeSlabTable, InvestmentDeclarationFormTable } from "./InvestmentDeclarationTables";
import usePermission from "../../config/permissions";

const InvestmentDeclarationDisplay = () => {

    const [toggleState, setToggleState] = useState(1);

    const getSelectedTitle = () => {
        switch (toggleState) {
            case 1:
                return 'Tax Regime';
            case 2:
                return ' Investment / Income Types';
            case 3:
                return 'Tax Sections';
            case 4:
                return 'Age Range';
            case 5:
                return 'Tax Slabs';
            case 6:
                return 'Surcharge Slabs';
            case 7:
                return 'Investment Form';
            default:
                return 'Investment Declaration Display';
        }
    };
    return (
        <>
            <div>
                <div className="bloc-tabss  wfm-margin" style={{ marginLeft: '0px', marginBottom: '20px' }}>
                    <button
                        className={toggleState === 1 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(1)}
                    >
                        Tax Regime
                    </button>

                    <button
                        className={toggleState === 2 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(2)}
                    >
                        Investment / Income Types
                    </button>
                    <button
                        className={toggleState === 3 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(3)}
                    >
                        Tax Section
                    </button>
                    <button
                        className={toggleState === 4 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(4)}
                    >
                        Age Range
                    </button>
                    <button
                        className={toggleState === 5 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(5)}
                    >
                        Tax Slabs
                    </button>
                    <button
                        className={toggleState === 6 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(6)}
                    >
                        Surcharge Slabs
                    </button>
                    <button
                        className={toggleState === 7 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(7)}
                    >
                        Investment Form
                    </button>
                    {/* )} */}
                </div>

                <div>

                    {toggleState === 1 ? <TaxRegimeTable /> : null}
                    {toggleState === 2 ? <InvestmentTypesTable /> : null}
                    {toggleState === 3 ? <TaxSectionTable /> : null}
                    {toggleState === 4 ? <AgeRangeForTaxSlabTable /> : null}
                    {toggleState === 5 ? <TaxSlabTable /> : null}
                    {toggleState === 6 ? <SurchargeSlabTable /> : null}
                    {toggleState === 7 ? <InvestmentDeclarationFormTable viewAccess={'hr'} /> : null}
                </div>
            </div>

        </>
    )
}

export default InvestmentDeclarationDisplay
